<div class="auth-layout h-100">
  <router-outlet></router-outlet>
</div>
